import { defineStore } from "pinia";
import { SubscriptionService } from "../components/Subscription/services/subscription-service";

export const useBillingStore = defineStore("billing", {
  state: () => ({
    exists: false,
    active: false,
    planId: null as string | null,
    currentPeriodEnd: null as string | null,
    cancelAtPeriodEnd: false,
  }),

  getters: {
    billingExists: (state) => state.exists,
  },

  actions: {
    async updateBillingStatus(): Promise<void> {
      const status = await SubscriptionService.fetchBillingStatus();
      this.exists = status.exists;
      this.active = status.active;
      this.planId = status.planId;
      this.currentPeriodEnd = status.currentPeriodEnd;
      this.cancelAtPeriodEnd = status.cancelAtPeriodEnd;
    },
  },
});
